import { handleReschedule } from "../../tables/WorkOrderRoutingTableV2/moveHelper";

export const SECTIONS_KEYS = {
  wax: "wax",
  assembly: "assembly",
  dip: "dip",
  autoclave: "autoclave",
  foundry: "foundry",
  post: "post",
};

export const getFieldLabel = (label = "") =>
  label
    ?.split(".")
    .map((word) => `${word[0].toUpperCase()}${word?.slice(1)}`)
    .join("")
    .replace(/([a-z](?=[A-Z]))/g, "$1 ");

export const STARTED_APPEND = "Cannot add a routing to a completed section";
export const STARTED_REORDER = "Cannot reorder a routing that has started";
export const STARTED_REMOVE = "Cannot remove a routing that has started";
export const STARTED_STATION = "Cannot change a routing that has started";

export const buildRouteOps = ({ getValues, setValue, addSnackbarError }) => {
  const validateNotStarted = (basePath, idx) => {
    const route = getValues(`${basePath}.routing[${idx}]`);
    if (route?.startDate) return true;
    else return false;
  };

  const getRouteIndex = (basePath, idx) => {
    const instructions = getValues("instructions");
    const routing = getValues(`${basePath}.routing`);
    const ridx = idx ?? routing?.length;

    const routes = instructions?.flatMap((ins, isx) =>
      ins.routing?.map((r, irx) => ({
        prefix: `instructions.${isx}.routing.${irx}`,
        ...r,
      })),
    );

    const prefix = `${basePath}.routing.${ridx}`;
    const index = routes?.findIndex((r) => r.prefix === prefix);

    if (index < 0) return false;

    const next = routes[index + 1];
    return { index, next };
  };

  const validateNextNotStarted = (basePath, idx) => {
    const { index, next } = getRouteIndex(basePath, idx);
    if (idx !== 0 && !idx) return false;
    if (next?.startDate) return false;
    else return index + 1;
  };

  const move = (basePath, start, end, move) => {
    try {
      const isStart = validateNotStarted(basePath, start);
      const isEnd = validateNotStarted(basePath, end);
      const { index } = getRouteIndex(basePath, Math.min(start, end));

      if (isStart || isEnd) addSnackbarError({ message: STARTED_REORDER });
      else if (index >= 0) {
        move(start, end);
        handleReschedule(index, getValues, setValue);
      } else addSnackbarError({ message: "Failed to move routes" });
    } catch (e) {
      console.error("Failed to move routes: ", e);
      addSnackbarError({ message: "Failed to move routes" });
    }
  };

  const remove = (basePath, idx, remove) => {
    try {
      const isStart = validateNotStarted(basePath, idx);
      const { index } = getRouteIndex(basePath, idx);

      if (isStart) addSnackbarError({ message: STARTED_REMOVE });
      else if (index >= 0) {
        remove(idx);
        handleReschedule(index, getValues, setValue);
      } else addSnackbarError({ message: "Failed to remove route" });
    } catch (e) {
      console.error("Failed to remove route: ", e);
      addSnackbarError({ message: "Failed to remove route" });
    }
  };

  const add = (basePath, idx, append) => {
    try {
      const index = validateNextNotStarted(basePath, Math.max(idx - 1, 0));
      if (!index) addSnackbarError({ message: STARTED_APPEND });
      else {
        append();
        handleReschedule(index, getValues, setValue);
      }
    } catch (e) {
      console.error("Failed to add route: ", e);
      addSnackbarError({ message: "Failed to add route" });
    }
  };

  return { move, remove, add };
};
